module.exports = "/images/tsunami@3x.png?a72547b3941395f062af689b9aad5e37";